import { apiClient, type TruckTypeEntity } from '@/libs/api'

export const fetchTruckTypes = async (
  tenantKey: string,
  signal?: AbortSignal
): Promise<TruckTypeEntity[]> => {
  const { data } = await apiClient._tenant(tenantKey).truck_types.$get({
    config: {
      signal
    }
  })
  return data
}
